import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertCircle, RefreshCw, X } from 'lucide-react';
import { useWallet } from '../contexts/WalletContext';

export default function WalletReconnectionPrompt() {
  const { confirmReconnection, dismissReconnectionPrompt } = useWallet();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[rgba(0,0,0,0.5)] backdrop-blur-sm">
      <Card className="w-full max-w-md mx-4 border-2 border-primary/50 shadow-2xl">
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle className="flex items-center gap-2">
              <AlertCircle className="h-5 w-5 text-yellow-500" />
              Wallet Session Detected
            </CardTitle>
            <Button
              variant="ghost"
              size="sm"
              onClick={dismissReconnectionPrompt}
              className="h-8 w-8 p-0"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
          <CardDescription>
            Your wallet session needs to be restored after switching apps
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-accent/30 rounded-lg p-4 space-y-2">
            <p className="text-sm text-muted-foreground">
              <strong>What happened?</strong>
            </p>
            <p className="text-xs text-muted-foreground">
              You switched to your mobile wallet app (Trust Wallet or MetaMask) to approve a connection.
              Your session is still active and can be restored.
            </p>
          </div>

          <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4 space-y-2">
            <p className="text-sm text-blue-500 font-medium">
              <strong>What will happen?</strong>
            </p>
            <p className="text-xs text-muted-foreground">
              We'll verify your wallet connection and restore your session. Your balances and
              transaction history will be refreshed automatically.
            </p>
          </div>

          <div className="flex gap-3">
            <Button
              onClick={confirmReconnection}
              className="flex-1 gap-2"
            >
              <RefreshCw className="h-4 w-4" />
              Restore Connection
            </Button>
            <Button
              variant="outline"
              onClick={dismissReconnectionPrompt}
              className="flex-1"
            >
              Dismiss
            </Button>
          </div>

          <p className="text-xs text-center text-muted-foreground">
            This is a WalletConnect v2 session recovery feature
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
